// import scrollTo from '../common/scrollTo'

const $form = $('.landing-page-form')
const form = document.querySelector('.landing-page-form')

export default {
  can: () => $form.length,
  run: () => {
    $form.on('submit', (e) => {
      e.preventDefault()

      const $submitButton = $form.find('[type=submit]')
      $submitButton.disabled = true
      $submitButton.addClass('loading')

      const formData = new FormData(form)

      //console.log(form.action)
      //console.log(formData)
      $.ajax({
        type: 'post',
        url: form.action,
        data: formData,
        dataType: 'json',
        processData: false,
        contentType: false,
        success: (resp) => {
          if (resp.success) {
            $form.addClass('form--success')

            $form.replaceWith(`<div class="form-success">${resp.message}</div>`)
            // scrollTo($anchor, 150)

            if (resp.file) {
              const download = document.createElement('form')
              download.action = resp.file
              console.log(download)
              $(document.body).append(download)
              download.submit()
            }
          } else {
            $form.addClass('form--error')
          }
        },
      })
    })
  },
}
